const initialState = {}

export default function quote(state = initialState, action) {
    switch (action.type) {
        case 'CHANGE_QUOTE': {
            return action.data
        }
        default: return state
    }
}